export default "__VITE_ASSET__OVUxdt4w__"